import React from 'react';
import { useTheme } from '../../context/ThemeContext';
import { CreditCard } from 'lucide-react';

const Billing = () => {
  const { theme } = useTheme();

  return (
    <div className={`p-4 md:p-6 w-full max-w-2xl mx-auto ${theme === 'light' ? 'text-gray-800' : 'text-gray-200'}`}>
      <h2 className="text-xl md:text-2xl font-bold mb-4 md:mb-6">Billing Settings</h2>

      {/* Current Plan Section */}
      <div className="mb-4 md:mb-6">
        <label className="block text-sm font-medium mb-2">Current Plan</label>
        <div className={`px-3 py-2 rounded-lg border ${
          theme === 'light' 
            ? 'border-gray-300 bg-gray-50 text-gray-900' 
            : 'border-gray-700 bg-gray-800 text-gray-100'
        }`}>
          Free Plan
        </div>
      </div>

      {/* Payment Method Section */}
      <div className="mb-4 md:mb-6">
        <label className="block text-sm font-medium mb-2">Payment Method</label>
        <div className="flex flex-col sm:flex-row gap-2">
          <div className={`flex-1 px-3 py-2 rounded-lg border ${
            theme === 'light' 
              ? 'border-gray-300 bg-gray-50 text-gray-400' 
              : 'border-gray-700 bg-gray-800 text-gray-500'
          }`}>
            No payment method added
          </div>
          <button
            disabled
            className={`w-full sm:w-auto px-2 md:px-2.5 py-1 text-xs font-medium border backdrop-blur-sm rounded-full transition-all duration-200 flex items-center justify-center gap-1 whitespace-nowrap ${
              theme === 'light'
                ? 'border-gray-300 text-gray-400 bg-gray-100 cursor-not-allowed'
                : 'border-gray-700 text-gray-500 bg-gray-800 cursor-not-allowed'
            }`}
          >
            <CreditCard size={16} />
            Add
          </button>
        </div>
      </div>

      {/* Billing History Section */}
      <div className="mb-4 md:mb-6">
        <label className="block text-sm font-medium mb-2">Billing History</label>
        <div className={`px-3 py-4 rounded-lg border text-center ${
          theme === 'light' 
            ? 'border-gray-300 bg-gray-50 text-gray-400' 
            : 'border-gray-700 bg-gray-800 text-gray-500'
        }`}>
          No billing history available
        </div>
      </div>

      {/* Upgrade Plan Button */}
      <button
        disabled
        className={`w-full px-4 py-2 text-sm font-medium border backdrop-blur-sm rounded-full transition-all duration-200 ${
          theme === 'light'
            ? 'border-gray-300 text-gray-400 bg-gray-100 cursor-not-allowed'
            : 'border-gray-700 text-gray-500 bg-gray-800 cursor-not-allowed'
        }`}
      >
        Upgrade Plan
      </button>
    </div>
  );
};

export default Billing;
